import { defineComponent, openBlock, createElementBlock, createElementVNode, toDisplayString } from "vue";
const _hoisted_1 = {
  class: "membership-rewards-tag"
};
const _sfc_main = /* @__PURE__ */ defineComponent({
  __name: "MembershipRewardsTag",
  props: {
    text: {
      default: ""
    }
  },
  setup(__props) {
    return (_ctx, _cache) => {
      return openBlock(), createElementBlock("div", _hoisted_1, [createElementVNode("span", null, toDisplayString(_ctx.text), 1)]);
    };
  }
});
export {
  _sfc_main as default
};
//# sourceMappingURL=MembershipRewardsTag.mjs.map
